// HERC Shopify Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
    // Initialize all components
    initNavbar();
    initMobileMenu();
    initProductTilt();
    initScrollAnimations();
    initSmoothScroll();
    initCartDrawer();
    initQuantitySelectors();
    initAddToCart();
});

// Navbar scroll effect
function initNavbar() {
    const navbar = document.querySelector('.site-header');
    if (!navbar) return;

    window.addEventListener('scroll', () => {
        if (window.scrollY > 50) {
            navbar.classList.add('scrolled');
        } else {
            navbar.classList.remove('scrolled');
        }
    });
}

// Mobile Menu functionality
function initMobileMenu() {
    const mobileMenuBtn = document.getElementById('mobileMenuBtn');
    const mobileNav = document.getElementById('mobileNav');
    const mobileNavOverlay = document.getElementById('mobileNavOverlay');
    const mobileNavClose = document.getElementById('mobileNavClose');

    if (!mobileMenuBtn || !mobileNav) return;

    function openMobileMenu() {
        mobileNav.classList.add('open');
        if (mobileNavOverlay) mobileNavOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileMenu() {
        mobileNav.classList.remove('open');
        if (mobileNavOverlay) mobileNavOverlay.classList.remove('open');
        document.body.style.overflow = '';
    }

    mobileMenuBtn.addEventListener('click', openMobileMenu);
    
    if (mobileNavClose) {
        mobileNavClose.addEventListener('click', closeMobileMenu);
    }
    
    if (mobileNavOverlay) {
        mobileNavOverlay.addEventListener('click', closeMobileMenu);
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && mobileNav.classList.contains('open')) {
            closeMobileMenu();
        }
    });

    // Close menu when clicking a link
    mobileNav.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', closeMobileMenu);
    });
}

// 3D Tilt Effect on Product Image
function initProductTilt() {
    const heroProduct = document.getElementById('heroProduct');
    if (!heroProduct) return;

    const productImg = heroProduct.querySelector('img');
    if (!productImg) return;

    heroProduct.addEventListener('mousemove', (e) => {
        const rect = heroProduct.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        
        const mouseX = e.clientX - centerX;
        const mouseY = e.clientY - centerY;
        
        const rotateY = (mouseX / (rect.width / 2)) * 15;
        const rotateX = -(mouseY / (rect.height / 2)) * 10;
        
        productImg.style.transform = `rotateY(${rotateY}deg) rotateX(${rotateX}deg)`;
    });

    heroProduct.addEventListener('mouseleave', () => {
        productImg.style.transform = 'rotateY(0deg) rotateX(0deg)';
    });
}

// Fade in on scroll
function initScrollAnimations() {
    const fadeElements = document.querySelectorAll('.fade-in');
    if (fadeElements.length === 0) return;

    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, observerOptions);

    fadeElements.forEach(el => observer.observe(el));
}

// Smooth scroll for anchor links
function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href === '#') return;
            
            e.preventDefault();
            const target = document.querySelector(href);
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

// Cart Drawer functionality
function initCartDrawer() {
    const cartDrawer = document.getElementById('cartDrawer');
    const cartOverlay = document.getElementById('cartOverlay');
    const cartToggle = document.querySelectorAll('[data-cart-toggle]');
    const cartClose = document.getElementById('cartClose');

    if (!cartDrawer) return;

    cartToggle.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            openCartDrawer();
        });
    });

    if (cartClose) {
        cartClose.addEventListener('click', closeCartDrawer);
    }

    if (cartOverlay) {
        cartOverlay.addEventListener('click', closeCartDrawer);
    }

    // Close on escape key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && cartDrawer.classList.contains('open')) {
            closeCartDrawer();
        }
    });
}

function openCartDrawer() {
    const cartDrawer = document.getElementById('cartDrawer');
    const cartOverlay = document.getElementById('cartOverlay');
    
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
}

function closeCartDrawer() {
    const cartDrawer = document.getElementById('cartDrawer');
    const cartOverlay = document.getElementById('cartOverlay');
    
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
}

// Quantity selectors
function initQuantitySelectors() {
    document.querySelectorAll('.quantity-selector').forEach(selector => {
        const minusBtn = selector.querySelector('[data-quantity-minus]');
        const plusBtn = selector.querySelector('[data-quantity-plus]');
        const input = selector.querySelector('input');

        if (minusBtn) {
            minusBtn.addEventListener('click', () => {
                const currentValue = parseInt(input.value) || 1;
                if (currentValue > 1) {
                    input.value = currentValue - 1;
                    input.dispatchEvent(new Event('change'));
                }
            });
        }

        if (plusBtn) {
            plusBtn.addEventListener('click', () => {
                const currentValue = parseInt(input.value) || 1;
                input.value = currentValue + 1;
                input.dispatchEvent(new Event('change'));
            });
        }
    });
}

// Add to Cart functionality
function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach(form => {
        form.addEventListener('submit', async function(e) {
            e.preventDefault();
            
            const submitBtn = this.querySelector('button[type="submit"]');
            const originalText = submitBtn.innerHTML;
            
            // Show loading state
            submitBtn.disabled = true;
            submitBtn.innerHTML = 'Adding...';

            const formData = new FormData(this);
            
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData
                });

                const data = await response.json();

                if (response.ok) {
                    // Update cart count
                    updateCartCount();
                    
                    // Open cart drawer
                    openCartDrawer();
                    
                    // Refresh cart drawer contents
                    refreshCartDrawer();
                    
                    // Show success
                    submitBtn.innerHTML = 'Added!';
                    setTimeout(() => {
                        submitBtn.innerHTML = originalText;
                        submitBtn.disabled = false;
                    }, 2000);
                } else {
                    throw new Error(data.description || 'Error adding to cart');
                }
            } catch (error) {
                console.error('Add to cart error:', error);
                submitBtn.innerHTML = 'Error';
                setTimeout(() => {
                    submitBtn.innerHTML = originalText;
                    submitBtn.disabled = false;
                }, 2000);
            }
        });
    });
}

// Update cart count in header
async function updateCartCount() {
    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        document.querySelectorAll('.cart-count').forEach(el => {
            el.textContent = cart.item_count || '';
        });
    } catch (error) {
        console.error('Error fetching cart:', error);
    }
}

// Refresh cart drawer contents
async function refreshCartDrawer() {
    const cartItems = document.getElementById('cartItems');
    const cartSubtotal = document.getElementById('cartSubtotal');
    const cartEmpty = document.getElementById('cartEmpty');
    const cartFooter = document.querySelector('.cart-drawer-footer');

    if (!cartItems) return;

    try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        if (cart.item_count === 0) {
            cartItems.innerHTML = '';
            if (cartEmpty) cartEmpty.style.display = 'block';
            if (cartFooter) cartFooter.style.display = 'none';
            return;
        }

        if (cartEmpty) cartEmpty.style.display = 'none';
        if (cartFooter) cartFooter.style.display = 'block';

        let itemsHTML = '';
        cart.items.forEach(item => {
            itemsHTML += `
                <div class="cart-item" data-line-key="${item.key}">
                    <img src="${item.image}" alt="${item.title}">
                    <div class="cart-item-details">
                        <h4>${item.product_title}</h4>
                        <p class="variant">${item.variant_title || ''}</p>
                        <p class="price">${formatMoney(item.final_line_price)}</p>
                        <div class="quantity-selector">
                            <button type="button" data-quantity-minus>−</button>
                            <input type="number" value="${item.quantity}" min="1" data-line-key="${item.key}">
                            <button type="button" data-quantity-plus>+</button>
                        </div>
                    </div>
                    <button class="cart-item-remove" data-remove-item="${item.key}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <path d="M18 6L6 18M6 6l12 12"/>
                        </svg>
                    </button>
                </div>
            `;
        });

        cartItems.innerHTML = itemsHTML;
        
        if (cartSubtotal) {
            cartSubtotal.textContent = formatMoney(cart.total_price);
        }

        // Re-init quantity selectors and remove buttons
        initCartItemControls();

    } catch (error) {
        console.error('Error refreshing cart:', error);
    }
}

// Initialize cart item controls (quantity, remove)
function initCartItemControls() {
    // Quantity changes
    document.querySelectorAll('.cart-item .quantity-selector').forEach(selector => {
        const minusBtn = selector.querySelector('[data-quantity-minus]');
        const plusBtn = selector.querySelector('[data-quantity-plus]');
        const input = selector.querySelector('input');
        const lineKey = input.dataset.lineKey;

        minusBtn.addEventListener('click', () => {
            const currentValue = parseInt(input.value) || 1;
            if (currentValue > 1) {
                updateCartItem(lineKey, currentValue - 1);
            }
        });

        plusBtn.addEventListener('click', () => {
            const currentValue = parseInt(input.value) || 1;
            updateCartItem(lineKey, currentValue + 1);
        });
    });

    // Remove buttons
    document.querySelectorAll('[data-remove-item]').forEach(btn => {
        btn.addEventListener('click', () => {
            const lineKey = btn.dataset.removeItem;
            updateCartItem(lineKey, 0);
        });
    });
}

// Update cart item quantity
async function updateCartItem(lineKey, quantity) {
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: lineKey,
                quantity: quantity
            })
        });

        if (response.ok) {
            updateCartCount();
            refreshCartDrawer();
        }
    } catch (error) {
        console.error('Error updating cart:', error);
    }
}

// Format money helper
function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
}

// Expose functions globally for use in Liquid templates
window.HercTheme = {
    openCartDrawer,
    closeCartDrawer,
    updateCartCount,
    refreshCartDrawer
};
